import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rIstatistikSonuc_4 } from '../../../../api/models/.catalog';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rIstatistikSonuc_4>,
  rIstatistikSonuc_4
>(
  ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER,
  DefaultInputDataStateModel<pList, rIstatistikSonuc_4>()
);
